import createCachedSelector from "re-reselect";
import * as actions from "./actionCreators";

const ids = (filters, page, pageSize, state) => {
  const key = actions.loadOffersKey(filters, pageSize);
  const responsibleChangeOffers = state.responsibleChangeOffers.list[key];
  if (!responsibleChangeOffers) {
    return [];
  }

  const result = responsibleChangeOffers[page] ? responsibleChangeOffers[page].ids : [];
  return result ? result : [];
};

const responsibleChangeOffers = (_filters, _page, _pageSize, state) =>
  state.entities.responsibleChangeOffers ? state.entities.responsibleChangeOffers : [];

export const getOffersCached = createCachedSelector(ids, responsibleChangeOffers, (ids, responsibleChangeOffers) =>
  ids.map(id => responsibleChangeOffers[id])
)((filters, _page, pageSize, _state) => actions.loadOffersKey(filters, pageSize));

export const getResponsibleChangeOffers = (filters, page, pageSize, state) => {
  const key = actions.loadOffersKey(filters, pageSize);
  const responsibleChangeOffers = state.responsibleChangeOffers.list[key];

  const loading =
    responsibleChangeOffers && responsibleChangeOffers[page] ? responsibleChangeOffers[page].loading : false;
  const loaded =
    responsibleChangeOffers && responsibleChangeOffers[page] ? responsibleChangeOffers[page].loaded : false;
  const totalCount =
    responsibleChangeOffers && responsibleChangeOffers.totalCount ? responsibleChangeOffers.totalCount : 0;
  const content = loaded ? getOffersCached(filters, page, pageSize, state) : [];

  return { loading, loaded, content, totalCount };
};
